import { FormService } from '../../InterestConflicts/services'

export default (form) => {
  return new Promise((resolve, reject) => {
    FormService.updateForm(form)
      .then(response => resolve(response.data))
      .catch(err => reject({ error: true }))
  })
}
